import { AnyObj } from "./types";

// performance mark的公共标识
export const commonMarkName = '--weapp-monitor'

// 提交性能数据后,插入的统一标识
export const perfMarkName = `${commonMarkName}-perf`;

// 消耗统计标识
export const consumeMarkName = `${commonMarkName}-consume`;

export const performanceKeyMap: AnyObj = {
  /**
  * 资源名称,是资源的绝对路径或调用mark方法自定义的名称
  */
  name: 1,

  /**
   * 资源类型: navigation | resource | paint | measure | mark
   */
  entryType: 1,
  
  /**
   * 计算后的准确时间戳, 通过addTak方法统一生成
   */
  timestamp: 1,
  
  /**
   * 加载时间
   */
  duration: 1,

  /**
   * 开始时间
   */
  startTime: 1,
  
  /**
   * 前一个网页（与当前页面同域）unload 的时间戳,如果无前一个网页 unload 或者前一个网页与当前页面不同域,则值为 0
   */
  unloadEventStart: 1,
  /**
   * 和 unloadEventStart 相对应,返回前一个网页 unload 事件绑定的回调函数执行完毕的时间戳
   */
  unloadEventEnd: 1,
    
  /**
   * 第一个HTTP重定向开始时的UNIX时间戳。如果没有重定向,或者重定向中的一个不同源,这个值会返回0
   */
  redirectStart: 1,
  
  /**
   * 最后一个HTTP重定向完成时（也就是说是HTTP响应的最后一个比特直接被收到的时间）的UNIX时间戳。如果没有重定向,或者重定向中的一个不同源,这个值会返回0.
   */
  redirectEnd: 1,
  
  /**
   * 浏览器准备好使用 HTTP 请求抓取文档的时间,这发生在检查本地缓存之前
   */
  fetchStart: 1,
  
  /**
   * DNS 域名查询开始的时间,如果使用了本地缓存（即无 DNS 查询）或持久连接,则与 fetchStart 值相等
   */
  domainLookupStart: 1,
  
  /**
   * DNS 域名查询完成的时间,如果使用了本地缓存（即无 DNS 查询）或持久连接,则与 fetchStart 值相等
   */
  domainLookupEnd: 1,
   
  /**
   * HTTP（TCP） 开始建立连接的时间,如果是持久连接,则与 fetchStart 值相等,如果在传输层发生了错误且重新建立连接,则这里显示的是新建立的连接开始的时间
   */
  connectStart: 1,
  /**
   * HTTP（TCP） 完成建立连接的时间（完成握手）,如果是持久连接,则与 fetchStart 值相等,如果在传输层发生了错误且重新建立连接,则这里显示的是新建立的连接完成的时间
   */
  connectEnd: 1,
    
  /**
   * HTTPS 连接开始的时间,如果不是安全连接,则值为 0
   */
  secureConnectionStart: 1,
  
  /**
   * HTTP 请求读取真实文档开始的时间（完成建立连接）,包括从本地读取缓存,连接错误重连时,这里显示的也是新建立连接的时间
   */
  requestStart: 1,
  
  /**
   * HTTP 开始接收响应的时间（获取到第一个字节）,包括从本地读取缓存
   */
  responseStart: 1,
  
  /**
   * HTTP 响应全部接收完成的时间（获取到最后一个字节）,包括从本地读取缓存
   */
  responseEnd: 1,

  /**
   * 开始解析渲染 DOM 树的时间,此时 Document.readyState 变为 loading,并将抛出 readystatechange 相关事件
   */
  domLoading: 1,
    
  /**
   * 完成解析 DOM 树的时间,Document.readyState 变为 interactive,并将抛出 readystatechange 相关事件
   */
  domInteractive: 1,
    
  /**
   * DOM 解析完成后,网页内资源加载开始的时间,文档发生 DOMContentLoaded事件的时间
   */
  domContentLoadedEventStart: 1,
  
  /**
   * DOM 解析完成后,网页内资源加载完成的时间（如 JS 脚本加载执行完毕）,文档的DOMContentLoaded 事件的结束时间
   */
  domContentLoadedEventEnd: 1,
  
  /**
   * DOM 树解析完成,且资源也准备就绪的时间,Document.readyState 变为 complete,并将抛出 readystatechange 相关事件
   */
  domComplete: 1,
  
  /**
   * load 事件发送给文档,也即 load 回调函数开始执行的时间,如果没有绑定 load 事件,值为 0
   */
  loadEventStart: 1,
    
  /**
   * load 事件的回调函数执行完毕的时间,如果没有绑定 load 事件,值为 0
   */
  loadEventEnd: 1,

  /** 
   * entryType 为“navigation”或"resource"才有的属性
   * 请求来源: 
   * navigation
   * 通过标签形式加载的资源，值是该节点名的小写形式，如 link/script/img/iframe
   * 通过css样式加载的资源，比如background的url方式加载资源，值是 css
   * 通过xhr加载的资源，值是 xmlhttprequest
   */
  initiatorType: 1,

  /** 
   * entryType 为“navigation”或"resource"才有的属性
   * 获取资源的大小（以八位字节为单位）的数字。包括响应头字段和响应payload body的大小。entryType 为“navigation”返回的只是获取html文件的大小
   */
  transferSize: 1,

  /** 
   * entryType 为“navigation”或"resource"才有的属性
   * 资源压缩前大小
   */
  encodedBodySize: 1,

  /** 
   * entryType 为“navigation”或"resource"才有的属性
   * 资源压缩后大小
   */
  decodedBodySize: 1,

  /** 
   * entryType 为“navigation”或"resource"才有的属性
   * 于获取资源的网络协议,例如 "http/1.1"
   */
  nextHopProtocol: 1,

  /** 
   * entryType 为“navigation”才有的属性
   * 如何导航到当前文档: navigate | reload | back_forward | prerender
   * navigate 通过点击链接,书签和表单提交,或者脚本操作,或者在浏览器的地址栏中输入URL
   * reload 通过浏览器的重新加载操作或location.reload
   * back_forward 通过历史记录和前进后退访问
   * prerender 由预渲染提示启动
   */
  type: 1,

  /** 
   * entryType 为“navigation”才有的属性
   * 自当前浏览上下文下的上次非重定向导航以来的重定向次数
   * 0: 没有重定向,或者重定向是从另一个来源出发的,并且该来源不允许将其计时信息公开给当前来源,则该值为
   * workerStart: 如果Service Worker线程已在运行,则在调用FetchEvent之前立即返回
   * DOMHighResTimeStamp: 如果尚未运行,则在启动Service Worker线程之前立即返回
   * DOMHighResTimeStamp: 如果资源未被Service Worker拦截,则该属性将始终返回0
   */
  redirectCount: 1
};

export const initMonitorSwitchStatus: AnyObj = {
  master: false,
  traceId: false, 
  route: false,
  render: false, 
  mobxAction: false, 
}